module.exports = __webpack_public_path__ + "static/img/payway4.68fee7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/payway4.png
// module id = W3SJ
// module chunks = 1